import React from 'react';
import * as s from './styles';

const Subscribe = ({ children, onClick }) => {
  return (
    <s.Button target='_blank' onClick={onClick}>
      {children}
    </s.Button>
  );
};

export default Subscribe;
